import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async () => {
  const URL = SERVER_PATH + apiEndpoints.sites

  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
